import * as React from 'react';

export function Form({ children, className, onSubmit }: { children: React.ReactNode, className?: string, onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void }) {
     return <form className={className} onSubmit={onSubmit}>{children}</form>;
}

export function FieldGroup({ children }: { children: React.ReactNode }) {
    return <div className={'space-y-4'}>{children}</div>;
}

export function FieldLabel({ children, ...props }: { children: React.ReactNode, [key: string]: any }) {
    return <label {...props}>{children}</label>;
}

export function Field({ children }: { children: React.ReactNode }) {
    return <div>{children}</div>;
}
